function insertRestockDate() {
  var redText = document.querySelector('p[style*="color: red"]');
  var dateEl = document.getElementById('restock-date-value');
  if (redText && dateEl && !document.getElementById('restock-date-text')) {
    var p = document.createElement('p');
    p.id = 'restock-date-text';
    p.style.marginTop = '0.25rem';
    p.innerHTML = 'Wieder verfügbar ab: <strong>' + dateEl.textContent + '</strong>';
    redText.parentNode.insertBefore(p, redText.nextSibling);
  }
}
setInterval(insertRestockDate, 300);
document.addEventListener('DOMContentLoaded', insertRestockDate);

